import React from 'react';
import PropTypes from "prop-types";
import { styleUtils } from '../../utils';

import { View, Row, Col } from '../View';
import Topbar from '../Topbar';
import Text from "../Text";
import WizardSteps from "../WizardSteps/WizardSteps";

import styles from './styles';
import {COLORS} from "../../design/tokens";
import {ONBOARD} from "../../constants/navigation";


const { style } = styleUtils;

const RootContainer = style(View, styles.rootContainer);
const TitleContainer = style(Row, styles.titleContainer);

const Header = ({step, title, showBreadcrumb, showTopbar, titlePosition, history}) => {
  return (
  <RootContainer>
    <View className="content-wrapper">
      {showTopbar && <Topbar/>}
      <TitleContainer>
        <Row type="flex" justify={titlePosition}>
          <Col><Text size="title" color={COLORS.WHITE}>{title}</Text></Col>
        </Row>
      </TitleContainer>
      { showBreadcrumb && <WizardSteps items={ONBOARD} step={step} history={history} /> }
    </View>
  </RootContainer>
)};

Header.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  titlePosition: PropTypes.oneOf(['start', 'center', 'end']),
  showBreadcrumb: PropTypes.bool
};

Header.defaultProps = {
  titlePosition: 'center',
  showBreadcrumb: true
};

export default Header
